/* Find your scent — inline expand */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fys-toggle]');
    if (!btn) return;
    var group = btn.closest('.fys__group');
    var panel = group.querySelector('[data-fys-panel]');
    if (!panel) return;
    var root = btn.closest('[data-fys]');
    var open = group.classList.contains('is-open');

    if (root && !open) {
      root.querySelectorAll('.fys__group.is-open').forEach(function (g) {
        if (g === group) return;
        g.classList.remove('is-open');
        var p = g.querySelector('[data-fys-panel]');
        if (p) p.hidden = true;
        var b = g.querySelector('[data-fys-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    group.classList.toggle('is-open', !open);
    panel.hidden = open;
    btn.setAttribute('aria-expanded', String(!open));
  });
})();
